// @flow
import edapWrapper from '@homeaway/edap-wrapper';

type EventName =
    | 'pageview'
    | 'edap.flush'
    | 'generic.event'
    | 'generic.error'
    | 'first hit hover'
    | 'page scroll'
    | 'search.map.move'
    | 'search.map.property.click'
    | 'search.map.pin.click'
    | 'search.map.hit.click'
    | 'search.map.zoom'
    | 'dated.search.submit'
    | 'search.submit'
    | 'search.hit.click'
    | 'multiunit.item.click'
    | 'multiunit.button.click'
    | 'multiunit.hit.exposed'
    | 'multiunit.hit.click'
    | 'multi_armed_bandit.presented'
    | 'multi_armed_bandit.selected'
    | 'search_query.submitted'
    | 'multiunit.result.count'
    | 'search_result_set.selected'
    | 'search_result_set.presented'
    | 'search_result.presented'
    | 'deepest_search_result.presented'
    | 'serp_hit.presented'
    | 'virtualtour_badge.presented'
    | 'virtualtour_badge_expansion.presented'
    | 'content_module.presented'
    | 'content_tile.presented'
    | 'content_tile.selected'
    | 'media.interaction'
    | 'nav.next.click'
    | 'nav.previous.click'
    | 'ux.cards_visible.adjusted';

export type EdapData = {
    eventaction: string,
    eventlabel?: string | number,
    highfrequency?: string,
    logmessage?: string
};

type EdapMapData = {
    zoomtype: string
};

type EdapHitClickData = {
    eventlistingids?: string,
    absoluteposition?: string,
    relativeposition?: string,
    badges?: string
};

export type EdapSerchResultSetPresentedData = {
    action_location: string,
    adult_count: ?string,
    child_count: ?string,
    date_end: ?string,
    date_start: ?string,
    with_pets?: ?string
};
export type EdapSerchResultSetSelectedData = {
    action_location: string,
    adult_count: ?string,
    child_count: ?string,
    date_end?: ?string,
    date_start?: ?string,
    with_pets?: ?string,
    listing_id: ?string,
    badges?: ?string
};

export type EdapVirtualTourData = {
    action_location: string,
    tourid: string
};

type EventData =
    | EdapData
    | EdapMapData
    | EdapHitClickData
    | EdapSerchResultSetPresentedData
    | EdapSerchResultSetSelectedData
    | EdapVirtualTourData;

export const GENERIC_EVENT = 'generic.event';

export const trigger = (
    name: EventName,
    data?: EventData,
    options?: Object = {}
): void => {
    let eventData;

    if (typeof window === 'undefined') {
        return;
    }

    // Default the eventcategory to 'search'
    eventData =
        name === GENERIC_EVENT ? {eventcategory: 'search', ...data} : data;

    try {
        edapWrapper().push({name, data: eventData, options});
    } catch (e) {
        // FIXME: log error with knotty
    }
};
